import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Textarea } from './ui/Textarea';
import { Mail, Phone, MapPin } from 'lucide-react';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    const formData = new FormData(e.currentTarget);
    // Web3Forms configuration
    formData.append('access_key', 'a74ac7e7-243d-47c2-833a-57f50f4ddf33');
    formData.append('subject', 'New Contact Form Submission from AMK Solutions Website');
    formData.append('from_name', 'AMK Solutions Website');
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        setIsSubmitted(true);
        e.currentTarget.reset();
      } else {
        setError('Failed to send message. Please try again or email us directly.');
      }
    } catch (err) {
      setError('Failed to send message. Please try again or email us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contact" className="py-20 bg-slate-50" data-id="element-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-14">
          {/* Contact Info */}
          <div data-id="element-15">
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-6" data-id="element-16">
              Let's Talk About Your Support Needs
            </h2>
            <p className="text-lg text-slate-600 mb-10" data-id="element-17">
              Ready to upgrade your customer support? Fill out the form and
              we'll get back to you within 24 hours to discuss a custom solution
              for your business.
            </p>

            <div className="space-y-8" data-id="element-18">
              <div className="flex items-start gap-4" data-id="element-19">
                <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-20">
                  <Mail className="h-5 w-5" data-id="element-21" />
                </div>
                <div data-id="element-22">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-23">
                    Email Us
                  </h3>
                  <a href="mailto:amksolutions10@gmail.com" className="text-slate-600 hover:text-blue-600 transition-colors" data-id="element-24">
                    amksolutions10@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-25">
                <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-26">
                  <Phone className="h-5 w-5" data-id="element-27" />
                </div>
                <div data-id="element-28">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-29">
                    Call Us
                  </h3>
                  <p className="text-slate-600" data-id="element-30">+1 (737) 3075405</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-31">
                <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-32">
                  <MapPin className="h-5 w-5" data-id="element-33" />
                </div>
                <div data-id="element-34">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-35">
                    Office
                  </h3>
                  <p className="text-slate-600" data-id="element-36">
                    Juia Plaza, Amir City
                    <br data-id="element-37" />
                    Khansar Road
                    <br data-id="element-38" />
                    Bhakkar
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-slate-100" data-id="element-39">
            {isSubmitted ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-40">
                <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-41">
                  <Mail className="h-8 w-8 text-green-600" data-id="element-42" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-43">
                  Message Sent!
                </h3>
                <p className="text-slate-600" data-id="element-44">
                  Thank you for contacting us. We will be in touch shortly.
                </p>
                <Button variant="outline" className="mt-8" onClick={() => setIsSubmitted(false)} data-id="element-45">
                  Send another message
                </Button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-46">
                <input type="hidden" name="redirect" value="https://amksol.com/success" data-id="element-47" />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-48">
                  <Input label="Name" name="name" placeholder="John Doe" required data-id="element-49" />
                  <Input label="Email" name="email" type="email" placeholder="john@company.com" required data-id="element-50" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-51">
                  <Input label="Phone Number" name="phone" type="tel" placeholder="+1 (737) 3075405" data-id="element-52" />
                  <Input label="Company" name="company" placeholder="Your Company Name" data-id="element-53" />
                </div>
                <Textarea label="Message" name="message" placeholder="Tell us about your support needs..." required data-id="element-54" />

                {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm" data-id="element-55">
                    {error}
                  </div>}

                <Button type="submit" className="w-full" size="lg" isLoading={isSubmitting} data-id="element-56">
                  Send Message
                </Button>
                <p className="text-xs text-slate-500 text-center mt-4" data-id="element-57">
                  By submitting this form, you agree to our privacy policy.
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}